<template>
  <div class="bg-white">
    <!-- FEATURE SECTION -->
    <div class="overflow-hidden py-12 sm:py-14">
      <div class="mx-auto max-w-7xl md:px-6 lg:px-8">
        <div class="grid grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:grid-cols-2 lg:items-start">
          <div class="px-6 md:px-0 lg:pr-4 lg:pt-4">
            <div class="mx-auto max-w-2xl lg:mx-0 lg:max-w-lg">
              <h2 class="text-base font-semibold leading-7 text-teal-600">
                Jetzt Studio Pro freischalten
              </h2>
              <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Erreiche deine nächsten Meilensteine mit KI-Anleitung
              </p>
              <p class="mt-6 text-lg leading-8 text-gray-600">
                Wachse mit einzigartigen Insights! Im Studio Pro erfährst du,
                mit welchem wirksamen Methoden-Mix ähnliche Podcasts ihre Ziele erreicht haben.
              </p>
              <dl class="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                <div v-for="feature in features" :key="feature.name" class="relative pl-9">
                  <dt class="inline font-semibold text-gray-900">
                    <component :is="feature.icon" class="absolute left-1 top-1 h-5 w-5 text-teal-700" aria-hidden="true" />
                    {{ feature.name }}
                  </dt>
                  {{ ' ' }}
                  <dd class="inline">
                    {{ feature.description }}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
          <div class="sm:px-6 lg:px-0">
            <div class="relative isolate overflow-hidden bg-teal-600 px-6 pt-8 sm:mx-auto sm:max-w-2xl sm:rounded-3xl sm:pl-16 sm:pr-0 sm:pt-16 lg:mx-0 lg:max-w-none">
              <div class="absolute -inset-y-px -left-3 -z-10 w-full origin-bottom-left skew-x-[-30deg] bg-teal-100 opacity-20 ring-1 ring-inset ring-white" aria-hidden="true" />
              <div class="mx-auto max-w-2xl sm:mx-0 sm:max-w-none">
                <img src="/images/conversion.png" alt="Jetzt Studio Pro freischalten" width="2432" height="1442" class="-mb-12 w-[57rem] max-w-none rounded-tl-xl bg-gray-800 ring-1 ring-white/10" />
              </div>
              <div class="pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/10 sm:rounded-3xl" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- PRICING PLANS -->
    <PricingPlans />
    <!-- DISMISS OPTION -->
    <div class="mx-auto max-w-7xl py-12 px-6 sm:py-12 lg:px-8">
      <div class="flex flex-col items-start gap-y-6 gap-x-8 rounded-3xl p-8 ring-1 ring-gray-900/10 sm:gap-y-10 sm:p-10 lg:col-span-2 lg:flex-row lg:items-center">
        <div class="lg:min-w-0 lg:flex-1">
          <h3 class="text-lg font-semibold leading-8 tracking-tight text-teal-600">
            Du brauchst keine Guidance?
          </h3>
          <p class="mt-1 text-base leading-7 text-gray-600">
            Dann geht es im kostenlosen Studio Basic mit eingeschränktem Funktionsumfang weiter für dich. Damit kannst du dauerhaft auf deine Methoden zugreifen und dein Podcast-Wachstum tracken.
          </p>
        </div>
        <router-link :to="{name: 'dashboard'}" class="rounded-md px-3.5 py-2 text-sm font-semibold leading-6 text-teal-600 ring-1 ring-inset ring-teal-600 hover:ring-teal-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-400">
          Zur Podcast-Übersicht <span aria-hidden="true">&rarr;</span>
        </router-link>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import { CheckCircleIcon } from '@heroicons/vue/20/solid';

const features =
[
  {
    icon: CheckCircleIcon,
    name: 'KI-Assistent:',
    description: 'Schalte dir Empfehlungen frei, die dich genau jetzt weiterbringen. Dein Kompass lernt fortlaufend, wie ähnliche Podcasts es vorgemacht haben und teilt das Wissen.',
  },
  {
    icon: CheckCircleIcon,
    name: 'Experimente:',
    description: 'Werde angeleitet, wie du die Effekte von angewandten Methoden auf deine Ziele verprobst.',
  },
  {
    icon: CheckCircleIcon,
    name: 'Benachrichtigungen:',
    description: 'Lass dich erinnern, wann es Zeit für deine nächste Auswertung wird und setze nur die wirksamsten Methoden fort.',
  },
  {
    icon: CheckCircleIcon,
    name: 'Indie-Support:',
    description: 'Dank dir können wir fortlaufend neue Methoden, Anleitungen und Funktionen zum Studio hinzufügen. Yeah!',
  },
];
</script>
